import './css/style.css'
import './css/dialog.css'
import loadingImg from '/src/img/loading.gif'
import config from './base'
import {
  i18nData,
  loadStyle,
  loadScript,
  debounce,
  regObj,
  thirdConf,
  inputEle,
  global,
  ajaxSuccessCode,
  accountHidden,
} from './base'
import md5 from './jquery.md5'
import { alert, confirm, toast } from './dialog'
import { JSEncrypt } from "encryptlong"
// import CryptoJS from 'crypto-js'
// import $ from 'jquery'
// import $ from 'webpack-zepto'

// alert('先吃饭割发代首过分的成功后')
// toast({type: 'loading'})
// confirm({ title: '我是标题',
//   content: '请打开麦克风',
//   doneText: '确认按钮文字',
//   cancalText: '取消按钮文字'
// }).then(() => { console.log('已确认') })
// .catch(() => { console.log('已取消') })

// 一体化组件主体
(function (global, factory) {
  'use strict'
  if (typeof module === 'object' && typeof module.exports === 'object') {
    // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    module.exports = global.document
      ? factory(global, true)
      : function (w) {
        if (!w.document) {
          throw new Error('Account requires a window with a document')
        }
        return factory(w)
      }
  } else {
    factory(global)
  }

  // Pass this if window is not defined yet
})(typeof window !== 'undefined' ? window : this, function (window) {
  // 网易易盾-行为验证码
  let onCloseFn
  let captchaIns   // 
  let accountLabel = ["mail", "phone", "account"]; // 账号输入框babel文案
  let accountPlaceholder = ['placeholder-nophone','placeholder-phone','placeholder']; // 账号输入框账号输入框placeholder文案
  let accountInvalid = ['invalid-nophone','invalid-phone','invalid']; // 账号输入框校验提示文案
  function initNECaptchaElement (element) {
    console.log('element---', element);   //登录的形式 no-password 验证码登录   password 密码登录
    captchaIns && captchaIns.validate && delete captchaIns.validate  // 清除 没有拿到 validate 之前的 captchaIns
    initNECaptcha(
      {
        // config对象，参数配置
        captchaId:
          global.NECaptcha.captchaId || '3d52897607474bf787201909fb95a880',
        element: '#' + element + '-captcha',
        mode: global.NECaptcha.mode || 'float',
        enableClose: global.NECaptcha.enableClose || false,
        lang: global.lang || 'zh-CN',
        width: global.NECaptcha.width || '100%',
        onVerify: function (err, data) {
          // 用户验证码验证成功后，进行实际的提交行为
          // todo
          console.log('页面初始化滑动成功后拿到的了 validate', data)
          captchaIns = Object.assign(captchaIns, data)
          Account.captchaBlur()
          if (!err && captchaIns.mode === 'popup') {
            // 验证成功后，调用close方法关闭弹框（enableClose为true时调用）
            // captchaIns.close()
          }
        },
        onClose: function () {
          // 弹出关闭结束后将会触发该函数
          typeof onCloseFn === 'function' && onCloseFn()
          console.log('NECaptcha close')
        },
      },
      function onload (instance) {
        console.log('onload===>', instance)
        captchaIns = instance
        // 初始化成功后得到验证实例instance，可以调用实例的方法
      },
      function onerror (err) {
        console.log('err===>', err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      }
    )
  }
  // loadStyle(config.resourceURL + config.resourceDIR + config.styleFile)

  // 登录组件功能逻辑相关
  function AccountComp () { }
  AccountComp.prototype = {
    // 登录插件初始化
    loginInit: function (params) {
      global = deepObjectMerge(global, params)
      console.log('---global--->', global)
      // console.log('---i18nData语言包--->',i18nData)
      setLang('_title', 'login')
      setLang('messages', 'notice', 'tip1')
      setLang('messages', 'notice', 'tip2', 0)
      global.title = global.title || setLang('_title', 'login') // i18nData[global.lang]._title.login
      // global.messages = Object.assign({}, i18nData[global.lang].messages)
      if (global.container) {
        $(global.container).html(this.loadingTpl() + this.initTpl().loginHtml)
      } else {
        toast({
          content: setLang('messages', 'notice', 'tip1'),
          type: 'error',
        })
        return false
      }
      //   console.log('this',this)
      this.initEvent()
      return this
    },
    //登陆状态下的第三方
    thirdpartyqueryInit: function () {
      console.log('---global-->', global)
      let { dataList } = global
      Object.keys(thirdConf).forEach(val => {
        let _a = dataList.filter(item => item.platformId === thirdConf[val].platform)
        if (_a.length) thirdConf[val].bind = true;
      })
      console.log('thirdConf', thirdConf)
      if (global.container) {
        $(global.container).html(this.initTpl().thirdpartyqueryHtml)
        this.thirdPartybindFn()
      } else {
        toast({
          content: setLang('messages', 'notice', 'tip1'),
          type: 'error',
        })
        return false
      }
    },
    //第三方登陆初始化
    thirdpartyInit: function (params) {
      console.log('params--->', params)
      global = deepObjectMerge(global, params)
      console.log(global)
      console.log(i18nData)
      global.title = global.title || setLang('_title', 'thirdparty')
      global.defaultMode = 'thirdconnect'//初始化注册
      if (global.container) {
        $(global.container).html(this.loadingTpl() + this.initTpl().thirdpartyHtml)
        $('#loginDiv').show()
      } else {
        toast({
          content: setLang('messages', 'notice', 'tip1'),
          type: 'error'
        })
        return false
      }
      this.initEvent()
      return this
    },
    // 注册插件初始化
    regsiterInit: function (params) {
      global = Object.assign(global, params)
      console.log(global)
      console.log(i18nData)
      global.title = global.title || setLang('_title', 'register') // i18nData[global.lang]._title.register
      global.defaultMode = 'register'
      if (global.container) {
        $(global.container).html(
          this.loadingTpl() + this.initTpl().registerHtml
        )
        // $('.register-block').removeClass('d-none')
      } else {
        toast({
          content: setLang('messages', 'notice', 'tip1'),
          type: 'error',
        })
        return false
      }
      this.initEvent()
      return this
    },
    // 重置密码插件初始化
    resetpasswordInit: function (params) {
      global = Object.assign(global, params)
      console.log(global)
      console.log(i18nData)
      global.title = global.title || setLang('_title', 'resetpassword')
      global.defaultMode = 'resetpassword'
      if (global.container) {
        $(global.container).html(
          this.loadingTpl() + this.initTpl().resetpasswordHtml
        )
        $('.resetpassword-block').removeClass('d-none')
      } else {
        toast({
          content: setLang('messages', 'notice', 'tip1'),
          type: 'error',
        })
        return false
      }
      this.initEvent()
      return this
    },
    // 账号注销插件初始化
    accountcancelInit: function (params) {
      global = Object.assign(global, params)
      console.log(global)
      console.log(i18nData)
      global.title = global.title || setLang('_title', 'accountcancel')
      global.defaultMode = 'accountcancel'
      if (global.container) {
        $(global.container).html(
          this.loadingTpl() + this.initTpl().accountcancelHtml
        )
        $('.accountcancel-block').removeClass('d-none')
      } else {
        toast({
          content: setLang('messages', 'notice', 'tip1'),
          type: 'error',
        })
        return false
      }
      this.initEvent()
      return this
    },
    //注销token组件
    logoutInit: function (params) {
      var _self = this
      if (params.logoutObj) {
        // $('body').on('click',params.container, function () {
        _self.logOutSubmit(params)
        // })
      } else {
        toast({
          content: setLang('messages', 'notice', 'tip1'),
          type: 'error',
        })
        return false
      }
    },
    // 事件初始化
    initEvent: function () {
      var _self = this
      global.currentMode = global.defaultMode
      global.loginType = global.typeSupport ? 'phone' : 'mail'
      console.log(global.defaultMode)
      switch (global.currentMode) {
        case 'accountcancel':
          // _self.resetPwdCheckCode()
          break
        case 'resetpassword':
          _self.resetPwdCheckCode()
        // break;
        case 'register':
          // $('.' + global.currentMode + '-form input').bind("input propertychange",function(event){
          //   console.log($(this).val())
          // });
          _self.getAuthCode()
          break
        default:
          _self.loginModeChange()
          _self.initLoginMode()
          _self.thirdPartyClick()
          _self.loginTypeChange()
          _self.thirdTypeChange()
          break
      }
      _self.agreementHandle()
      _self.md5Init()
      _self.inputBlur()
      _self.initInputSize()
      _self.passwordEye()
      _self.getPublicKey()
      $('button.submit')
        .off()
        .on('click', function (el) {
          // el.onclick = function(){
          // console.log(el)
          _self.infoSubmit()
          // }
        })
      // 用户名输入判断是否手机，显隐国家码选择框
      // $('input[name=phone]').on('keyup', function () {
      //   let val = $(this).val()
      //   if (val.length >= 7 && /^\d{1,}$/.test(val)) {
      //     $('select[name=country]').parent().removeClass('d-none')
      //   } else {
      //     $('select[name=country]').parent().addClass('d-none')
      //   }
      // })
      $(
        'input[name=password],input[name=authCode],input[name=confirm-password]'
      ).on('keyup', function (event) {
        // console.log(123);
        if (event.keyCode == 13) {
          $(this).parents('.form-group').siblings('button').on('click')
        }
      })
    },
    loadingTpl () {
      return `<div id="account-loading" style="line-height: 20px;"><img style="width: 20px;float: left; margin-right: 5px;" src="${loadingImg}" />${setLang(
        'loading'
      )}...</div>`
    },
    //第三方已有账号关联
    thirdpartyconnectTpl () {
      var formStr = global.thirdregisterShow
        ? '<div class="form thirdconnect-form card-body p-0 d-none">' +
        '<div class="form-group">' +
        '<span class="text-span">' + setLang("messages", "phone", "text") + '</span>' +
        '<input class="form-control" name="phone" placeholder="' +
        setLang('messages', 'phone', 'placeholder') +
        '" required="">' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'phone', 'invalid') +
        '</div>' +
        '</div>' +
        // '<div class="form-group">' +
        // '<input class="form-control" name="username" placeholder="' +
        // setLang(
        // 'messages',
        // 'username',
        // 'placeholder'
        // ) +
        // '" required="">' +
        // '<div class="invalid-feedback">' +
        // setLang(
        // 'messages',
        // 'username',
        // 'invalid'
        // ) +
        // '</div>' +
        // '</div>' +
        '<div class="form-group pr">' +
        '<span class="password-eye off"></span>' +
        '<span class="text-span">密码</span>' +
        '<input type="password" class="form-control" name="password" placeholder="' +
        setLang('messages', 'password', 'placeholder') +
        '" required="">' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'password', 'invalid') +
        '</div>' +
        '</div>' +
        // '<div class="form-group">' +
        // '<input class="form-control" name="captcha" placeholder="' +
        // setLang('messages', 'authCode', 'placeholder-captcha') +
        // '" required="">' +
        // '<div class="invalid-feedback">' +
        // setLang('messages', 'authCode', 'invalid-captcha') +
        // '</div>' +
        // '</div>' +
        '<div class="form-group">' +
        '<div id="thirdconnect-captcha"></div>' +
        (global.NECaptcha.mode === 'popup'
          ? ''
          : '<div class="invalid-feedback">' +
          setLang('messages', 'captcha.invalid') +
          '</div>') +
        '</div>' +
        '<div class="form-group">' +
        '<div class="input-group d-none">' + 
        '<span class="text-span">' + setLang("messages", "authCode", "text") + '</span>' +
        '<input type="text" class="form-control" name="authCode" placeholder="' +
        setLang('messages', 'authCode', 'placeholder') +
        '" required="" autocomplete="off">' +
        '<div class="input-group-append">' +
        '<button class="btn btn-outline-secondary  " type="button" id="thirdconnect-getAuthCode" data-url="">' +
        setLang('messages', 'authCode', 'getButton') +
        '</button>' +
        '<span class=" btn-outline-secondary countdown btn d-none">60s</span>' +
        '</div>' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'authCode', 'invalid') +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="form-group clearfix mb-5">' +
        '<a class="btn_thirdConnect fl" data-type="accountPassword">' +
        setLang('messages', 'accountpasswordBtn') +
        '</a>' +
        '</div>' +
        '<button class="btn btn-primary btn-block  sf_do submit">' +
        setLang('messages', 'connectBtn') +
        '</button>' +
        '</div>'
        : ''
      var btnStr = global.thirdconnectShow
        ? '<a href="javascript:;" class="mx-3 login-mode" data-mode="thirdconnect">' +
        setLang('messages', 'loginMode', 'third-connect') +
        '</a>'
        : ''
      return {
        btnStr,
        formStr
      }
    },
    //第三方注册
    thirdpartyregisterTpl () {
      var formStr = global.thirdregisterShow
        ? '<div class="form thirdregister-form card-body p-0 d-none">' +
        '<div class="form-group">' +
        '<input class="form-control" name="phone" placeholder="' +
        setLang('messages', 'phone', 'placeholder') +
        '" required="">' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'phone', 'invalid') +
        '</div>' +
        '</div>' +
        // '<div class="form-group">' +
        // '<input class="form-control" name="captcha" placeholder="' +
        // setLang('messages', 'authCode', 'placeholder-captcha') +
        // '" required="">' +
        // '<div class="invalid-feedback">' +
        // setLang('messages', 'authCode', 'invalid-captcha') +
        // '</div>' +
        // '</div>' +
        '<div class="form-group">' +
        '<div id="thirdregister-captcha"></div>' +
        (global.NECaptcha.mode === 'popup'
          ? ''
          : '<div class="invalid-feedback">' +
          setLang('messages', 'captcha.invalid') +
          '</div>') +
        '</div>' +
        '<div class="form-group mt-3">' +
        '<div class="input-group">' +
        '<input type="text" class="form-control" name="authCode" placeholder="' +
        setLang('messages', 'authCode', 'placeholder') +
        '" required="" autocomplete="off">' +
        '<div class="input-group-append">' +
        '<button class="btn btn-outline-secondary  " type="button" id="thirdregister-getAuthCode" data-url="">' +
        setLang('messages', 'authCode', 'getButton') +
        '</button>' +
        '<span class=" btn-outline-secondary countdown btn d-none">60s</span>' +
        '</div>' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'authCode', 'invalid') +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="form-group pr">' +
        '<input class="form-control" type="password" name="resg-password" placeholder="' +
        setLang('messages', 'resg-password', 'placeholder') +
        '" required="">' +
        '<span class="password-eye off"></span>' +
        '<p class="password-rule">' +
        setLang('messages', 'resg-password', 'rule') +
        '</p>' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'resg-password', 'invalid') +
        '</div>' +
        '</div>' +
        '<div class="form-group pr">' +
        '<input class="form-control" type="password" name="confirm-password" placeholder="' +
        setLang('messages', 'confirm-password', 'placeholder') +
        '" required="">' +
        '<span class="password-eye off"></span>' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'confirm-password', 'invalid') +
        '</div>' +
        '</div>' +
        '<button class="btn btn-primary btn-block  sf_do submit">' +
        setLang('messages', 'registerBindBtn') +
        '</button>' +
        '</div>'
        : ''
      var btnStr = global.thirdregisterShow
        ? '<a href="javascript:;" class="mx-3 login-mode" data-mode="thirdregister">' +
        setLang('messages', 'loginMode', 'third-register') +
        '</a>' +
        '<span class="border-left"></span>'
        : ''
      return {
        btnStr,
        formStr
      }
    },
    // 微信登录Tpl
    weixinTpl () {
      var formStr = global.weixinShow
        ? '<div class="form weixin-form card-body p-0 d-none">' +
        '<div class="text-center">' +
        '<div class="qrCode"><img src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQH27zwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyaG1QcGhMaEZjODMxS0Nnb052Y0UAAgROzphfAwRYAgAA" style="width: 160px; height: 160px;"></div>' +
        '<div class="mt-2"><svg class="svg-inline--fa fa-weixin fa-w-18" style="color: #00B500;" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="weixin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"></path></svg>' +
        '微信扫码<br>关注公众号后登录</div>' +
        '</div>' +
        '</div>'
        : ''
      var btnStr = global.weixinShow
        ? '<a href="javascript:;" class="mx-3 login-mode" data-mode="weixin">' +
        setLang('messages', 'loginMode', 'weixin') +
        '</a>' +
        '<span class="border-left"></span>'
        : ''
      return {
        formStr,
        btnStr,
      }
    },
    // 密码登录Tpl
    passwordTpl () {
      return {
        formStr: global.passwordShow
          ? '<div class="form password-form d-none" role="form">' +
          // '<div class="form-group d-none">' +
          // '<select class="form-control" name="country" placeholder="'+ setLang('messages', name.placeholder +'" required="">' +
          // '<option>国家/地区 | 中国</option>'+
          // '</select>'+
          // '<div class="invalid-feedback">'+ setLang('messages', name.invalid +'</div>'+
          // '</div>' +
          '<div class="form-group ' +
          (global.typeSupport ? '' : 'd-none') +
          '">' +
          '<span class="text-span">' + setLang("messages", "phone", "text") + '</span>' +
          '<input class="form-control" name="phone" placeholder="' +
          setLang('messages', 'phone', 'placeholder') +
          '" required="">' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'phone', 'invalid') +
          '</div>' +
          '</div>' +
          '<div class="form-group ' +
          (!global.typeSupport ? '' : 'd-none') +
          '">' +
          '<span class="text-span">' + setLang("messages", "mail", "text") + '</span>' +
          '<input class="form-control" name="mail" placeholder="' +
          setLang('messages', 'mail', 'placeholder') +
          '" required="">' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'mail', 'invalid') +
          '</div>' +
          '</div>' +
          '<div class="form-group pr">' +
          '<span class="password-eye off"></span>' +
          '<span class="text-span">' + setLang("messages", "password", "text") + '</span>' +
          '<input type="password" class="form-control" name="password" placeholder="' +
          setLang('messages', 'password', 'placeholder') +
          '" required="">' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'password', 'invalid') +
          '</div>' +
          '</div>' +
          '<div class="form-group">' +
          '<div id="password-captcha"></div>' +
          (global.NECaptcha.mode === 'popup'
            ? ''
            : '<div class="invalid-feedback">' +
            setLang('messages', 'captcha.invalid') +
            '</div>') +
          '</div>' +
          '<div class="form-group clearfix mb-5">' +
          (global.typeSupport === 2
            ? '<a class="login-type fl">' +
            setLang('messages', 'loginType', 'mailCode') +
            '</a>'
            : '') +
          '<a class="fr text-weight" href="' +
          global.resetPwdLink +
          '">' +
          setLang('messages', 'forget') +
          '</a>' +
          '</div>' +
          '<button class="btn btn-primary btn-block  sf_do submit">' +
          setLang('messages', 'submitButtonText') +
          '</button>' +
          '</div>'
          : '',
        btnStr:
          '<a href="javascript:;" class="mx-3 login-mode" data-mode="password">' +
          setLang('messages', 'loginMode', 'password') +
          '</a>' +
          '<span class="border-left"></span>',
      }
    },
    // 免密码（验证码）登录Tpl
    noPasswordTpl () {
      return {
        formStr: global['no-passwordShow']
          ? '<div class="form no-password-form d-none" role="form">' +
          // '<div class="form-group">' +
          // '<select class="form-control" name="country" placeholder="'+ setLang('messages', 'country', placeholder +'" required="">' +
          // '<option>国家/地区 | 中国</option>'+
          // '<option>国家/地区 | mei国</option>'+
          // '<option>国家/地区 | 英国</option>'+
          // '</select>'+
          // '<div class="invalid-feedback">'+ setLang('messages', 'country', invalid +'</div>'+
          // '</div>' +
          '<div class="form-group ' +
          (global.typeSupport ? '' : 'd-none') +
          '">' + 
          '<span class="text-span">' + setLang("messages", "phone", "text") + '</span>' +
          '<input class="form-control" type="text" name="phone" placeholder="' +
          setLang('messages', 'phone', 'placeholder') +
          '" required="">' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'phone', 'invalid') +
          '</div>' +
          '</div>' +
          '<div class="form-group ' +
          (!global.typeSupport ? '' : 'd-none') +
          '">' +
          '<span class="text-span">' + setLang("messages", "mail", "text") + '</span>' +
          '<input class="form-control" name="mail" placeholder="' +
          setLang('messages', 'mail', 'placeholder') +
          '" required="">' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'mail', 'invalid') +
          '</div>' +
          '</div>' +
          '<div class="form-group">' +
          '<div id="no-password-captcha"></div>' +
          (global.NECaptcha.mode === 'popup'
            ? ''
            : '<div class="invalid-feedback">' +
            setLang('messages', 'captcha.invalid') +
            '</div>') +
          '</div>' +
          '<div class="form-group  group-rela">' +
          '<div class="input-group">' +
          '<span class="text-span">' + setLang("messages", "authCode", "text") + '</span>' +
          '<input type="text" class="form-control" name="authCode" placeholder="' +
          setLang('messages', 'authCode', 'placeholder') +
          '" required="" autocomplete="off">' +
          '<div class="input-group-append">' +
          '<button class="btn btn-outline-secondary  " type="button" id="no-password-getAuthCode" data-url="">' +
          setLang('messages', 'authCode', 'getButton') +
          '</button>' +
          '<span class=" btn-outline-secondary countdown btn d-none">60s</span>' +
          '</div>' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'authCode', 'invalid') +
          '</div>' +
          '</div>' +
          '</div>' +
          '<div class="form-group clearfix mb-5">' +
          (global.typeSupport === 2
            ? '<a class="login-type fl">' +
            setLang('messages', 'loginType', 'mailCode') +
            '</a>'
            : '') +
          // '<a class="login-type fl">'+ setLang('messages', loginType.mailCode +'</a>' +
          '</div>' +
          '<button class="btn btn-primary  btn-block submit">' +
          setLang('messages', 'submitButtonText') +
          '</button>' +
          '</div>'
          : '',
        btnStr:
          '<a href="javascript:;" class="mx-3 login-mode" data-mode="no-password">' +
          setLang('messages', 'loginMode', 'no-password') +
          '</a>',
      }
    },
    // 注册Tpl
    registerTpl () {
      let agreement = global.agreementShow
        ? '<label for="agreementCheck" class="form-group fs-1 clearfix mt-2">' +
        '<span class="text-weight">*</span><input id="agreementCheck" name="agreement" type="checkbox"></input> ' +
        setLang('messages', 'registerTip') +
        '《<a class="register-agreement text-weight" href="javascript:;">' +
        setLang('messages', 'registerBtn') +
        '</a>》' +
        '《<a class="privacy-agreement  text-weight" href="javascript:;">' +
        setLang('messages', 'privacyBtn') +
        '</a>》' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'agreement', 'invalid') +
        '</div>' +
        '</label>'
        : ''
      let formStr = '<div class="form register-form">' +
        '<div class="form-group d-none">' +
        '<select class="form-control" name="country" placeholder="' +
        setLang('messages', 'country', 'placeholder') +
        '" required="">' +
        '<option>国家/地区 | 中国</option>' +
        '</select>' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'country', 'invalid') +
        '</div>' +
        '</div>' +
        '<div class="form-group">' +
        '<span class="text-span">'+ setLang("messages", accountLabel[global.typeSupport], "text") +'</span>' +
        '<input class="form-control" name="username" placeholder="' +
        setLang(
          'messages',
          'username',
          accountPlaceholder[global.typeSupport]
        ) +
        '" required="">' +
        '<div class="invalid-feedback">' +
        setLang(
          'messages',
          'username',
          accountInvalid[global.typeSupport]
        ) +
        '</div>' +
        '</div>' +
        '<div class="form-group">' +
        '<div id="register-captcha"></div>' +
        (global.NECaptcha.mode === 'popup'
          ? ''
          : '<div class="invalid-feedback">' +
          setLang('messages', 'captcha.invalid') +
          '</div>') +
        '</div>' +
        '<div class="form-group">' +
        '<div class="input-group">' +
        '<span class="text-span">' + setLang("messages", "authCode", "text") + '</span>' +
        '<input type="text" class="form-control" name="authCode" placeholder="' +
        setLang('messages', 'authCode', 'placeholder') +
        '" required="" autocomplete="off">' +
        '<div class="input-group-append">' +
        '<button class="btn btn-outline-secondary" type="button" id="register-getAuthCode" data-url="">' +
        setLang('messages', 'authCode', 'getButton') +
        '</button>' +
        '<span class="btn-outline-secondary countdown btn d-none">60s</span>' +
        '</div>' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'authCode', 'invalid') +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="form-group pr">' +
        '<span class="text-span">' + setLang("messages", "password", "text") + '</span>' +
        '<input class="form-control" type="password" name="resg-password" placeholder="' +
        setLang('messages', 'resg-password', 'placeholder') +
        '" required="">' +
        '<span class="password-eye off"></span>' +
        '<p class="password-rule">' +
        setLang('messages', 'resg-password', 'rule') +
        '</p>' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'resg-password', 'invalid') +
        '</div>' +
        '</div>' +
        '<div class="form-group pr">' +
        '<span class="text-span">' + setLang("messages", "password", "text") + '</span>' +
        '<input class="form-control" type="password" name="confirm-password" placeholder="' +
        setLang('messages', 'confirm-password', 'placeholder') +
        '" required="">' +
        '<span class="password-eye off"></span>' +
        '<div class="invalid-feedback">' +
        setLang('messages', 'confirm-password', 'invalid') +
        '</div>' +
        '</div>' +
        agreement;

      return {
        formStr,
        tpl:
          '<div class="card-body register-block">' +
          '<h3 class="text-center mb-3">' +
          global.title +
          '</h3>' +
          formStr +
          '<button class="btn btn-primary  btn-block submit mt-3">' +
          setLang('messages', 'confirmButtonText') +
          '</button>' +
          '</div>' +
          '</div>',
      }
    },
    // 重置密码Tpl
    resetPasswordTpl () {
      const resetNameItem =
        global.resetName === ''
          ? // 无账号
          '<div class="form-group">' +
          '<span class="text-span">'+ setLang("messages", accountLabel[global.typeSupport], "text") +'</span>' +
          '<input class="form-control" name="username" placeholder="' +
          setLang(
            'messages',
            'username',
            accountPlaceholder[global.typeSupport]
          ) +
          '" required="">' +
          '<div class="invalid-feedback">' +
          setLang(
            'messages',
            'username',
            accountInvalid[global.typeSupport]
          ) +
          '</div>' +
          '</div>'
          : // 有账号
          '<div class="form-group">' +
          '<p class="reset-account">' +
          setLang('messages', 'resetPwdTip', 0) +
          '<br>' +
          setLang('messages', 'resetPwdTip', 1) +
          '<span id="reset-account">' +
          accountHidden(global.resetName) +
          '</span></p>' +
          '<input class="" name="username" value="' +
          global.resetName +
          '" type="hidden" required="">' +
          '</div>'
      return {
        formStr:
          '<div class="card-body resetpassword-block">' +
          '<h3 class="text-center mb-5 mt-3">' +
          global.title +
          '</h3>' +
          '<div class="form resetpassword-form">' +
          '<div class="resetpassword-step1">' +
          '<div class="form-group d-none">' +
          '<select class="form-control" name="country" placeholder="' +
          setLang('messages', 'country', 'placeholder') +
          '" required="">' +
          '<option>国家/地区 | 中国</option>' +
          '</select>' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'country', 'invalid') +
          '</div>' +
          '</div>' +
          resetNameItem +
          '<div class="form-group">' +
          '<div id="resetpassword-captcha"></div>' +
          (global.NECaptcha.mode === 'popup'
            ? ''
            : '<div class="invalid-feedback">' +
            setLang('messages', 'captcha.invalid') +
            '</div>') +
          '</div>' +
          '<div class="form-group">' +
          '<div class="input-group">' +
          '<span class="text-span">' + setLang("messages", "authCode", "text") + '</span>' +
          '<input type="text" class="form-control" name="authCode" placeholder="' +
          setLang('messages', 'authCode', 'placeholder') +
          '" required="" autocomplete="off">' +
          '<div class="input-group-append">' +
          '<button class="btn btn-outline-secondary " type="button" id="resetpassword-getAuthCode" data-url="">' +
          setLang('messages', 'authCode', 'getButton') +
          '</button>' +
          '<span class=" btn-outline-secondary countdown btn d-none">60s</span>' +
          '</div>' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'authCode', 'invalid') +
          '</div>' +
          '</div>' +
          '</div>' +
          '<button class="btn btn-primary btn-block next mb-5">' +
          setLang('messages', 'nextButtonText') +
          '</button>' +
          '</div>' +
          '<div class="resetpassword-step2 d-none">' +
          '<div class="form-group pr">' +
          '<span class="text-span">' + setLang("messages", "password", "text") + '</span>' +
          '<input class="form-control" type="password" name="resg-password" placeholder="' +
          setLang('messages', 'resg-password', 'placeholder') +
          '" required="">' +
          '<span class="password-eye off"></span>' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'resg-password', 'invalid') +
          '</div>' +
          '<p class="password-rule">' +
          setLang('messages', 'resg-password', 'rule') +
          '</p>' +
          '</div>' +
          '<div class="form-group pr">' +
          '<span class="text-span">' + setLang("messages", "password", "text") + '</span>' +
          '<input class="form-control" type="password" name="confirm-password" placeholder="' +
          setLang('messages', 'confirm-password', 'placeholder') +
          '" required="">' +
          '<span class="password-eye off"></span>' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'confirm-password', 'invalid') +
          '</div>' +
          '</div>' +
          '<button class="btn btn-primary  btn-block submit">' +
          setLang('messages', 'confirmButtonText') +
          '</button>' +
          '</div></div>' +
          '</div>',
      }
    },
    // 账号注销Tpl
    accountCancelTpl () {
      const cancelNameItem =
        global.cancelName === ''
          ? // 无账号
          '<div class="form-group">' +
          '<input class="form-control" name="username" placeholder="' +
          setLang(
            'messages',
            'username',
            accountPlaceholder[global.typeSupport]
          ) +
          '" required="">' +
          '<div class="invalid-feedback">' +
          setLang(
            'messages',
            'username',
            accountInvalid[global.typeSupport]
          ) +
          '</div>' +
          '</div>'
          : // 有账号
          '<div class="form-group">' +
          '<p class="reset-account">' +
          setLang('messages', 'accountCancelTip', 0) +
          '<span id="reset-account">' +
          accountHidden(global.cancelName) +
          '</span>' +
          setLang('messages', 'accountCancelTip', 1) +
          '</p>' +
          '<input class="" name="username" value="' +
          global.cancelName +
          '" type="hidden" required="">' +
          '</div>'
      return {
        formStr:
          '<div class="card-body accountcancel-block">' +
          '<h3 class="text-center mb-5 mt-3">' +
          global.title +
          '</h3>' +
          '<div class="form accountcancel-form">' +
          cancelNameItem +
          '<div class="form-group">' +
          '<div id="accountcancel-captcha"></div>' +
          (global.NECaptcha.mode === 'popup'
            ? ''
            : '<div class="invalid-feedback">' +
            setLang('messages', 'captcha.invalid') +
            '</div>') +
          '</div>' +
          '<div class="form-group pr">' +
          '<span class="password-eye off"></span>' +
          '<span class="text-span">密码</span>' +
          '<input type="password" class="form-control" name="password" placeholder="' +
          setLang('messages', 'password', 'placeholder') +
          '" required="">' +
          '<div class="invalid-feedback">' +
          setLang('messages', 'password', 'invalid') +
          '</div>' +
          '</div>' +
          '<button class="btn btn-primary btn-block submit mb-5">' +
          setLang('messages', 'confirmButtonText') +
          '</button>' +
          '</div></div>' +
          '</div>',
      }
    },
    // 第三方登录绑定账号
    thirdPartyBindTpl () {

    },
    // 初始化Tpl
    initTpl: function () {
      let agreement = global.agreementShow
        ? `<a class="fr privacy-agreement text-weight" href="javascript:;">
                ${setLang('messages', 'privacyBtn')}
                </a>`
        : ''
      let thirdStr = `<div class="login-3rd text-center mt-3">
                <div class="3rd-btn-group mt-3 font-size-20">`
      const thirdConfKey = global.thirdParty.types, len = thirdConfKey.length, moreFlag = 3
      thirdConfKey.map((key, index) => {
        const item = thirdConf[key]
        let str = `<a href="javascript:;" data-platform="${item.platform}" class="px-1 ${index > moreFlag - 1 ? 'd-none' : ''}">
              <img style="width:28px;" src="${item.icon}"/>
            </a>`
        str = (index === moreFlag - 1 && len > moreFlag) ? `${str}
        <span id="showMore" class="px-1" style="color: #6C757D; cursor: pointer">
          <svg class="svg-inline--fa fa-ellipsis-h fa-w-16" aria-hidden="true" focusable="false" data-prefix="far" data-icon="ellipsis-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M304 256c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zm120-48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-336 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"></path></svg><!-- <i class="far fa-ellipsis-h"></i> -->
        </span>` : str
        thirdStr += str
      })
      thirdStr += '</div></div>'
      //   console.log(thirdConf);
      // <span id="loginShowMore" class="px-1" style="color: #6C757D; cursor: pointer">
      //     <svg class="svg-inline--fa fa-ellipsis-h fa-w-16" aria-hidden="true" focusable="false" data-prefix="far" data-icon="ellipsis-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M304 256c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zm120-48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-336 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"></path></svg><!-- <i class="far fa-ellipsis-h"></i> -->
      // </span>
      // <a href="/user/oauth/linkedin" class="d-none px-1" style="color: #0077B9">
      //     <svg class="svg-inline--fa fa-linkedin fa-w-14" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="linkedin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path></svg><i class="fab fa-linkedin"></i>
      // </a>
      let loginStr = '<div class="card-body login-block mt-3">' +
        '<h3 class="text-center">' +
        '<span class="tcl-logo"></span>' +
        '<span>' + global.title +
        '</span>' +

        '</h3>' +
        '<div class="login-nav text-center">' +
        this.weixinTpl().btnStr +
        this.passwordTpl().btnStr +
        this.noPasswordTpl().btnStr +
        '</div>' +
        this.weixinTpl().formStr +
        this.passwordTpl().formStr +
        this.noPasswordTpl().formStr +
        '<div class="form-group clearfix mt-3">' +
        '<a class="fl text-weight" href="' +
        global.registerLink +
        '">' +
        setLang('messages', 'loginRegBtn') +
        '</a>' +
        agreement +
        '</div>' +
        (global.thirdParty.show ? thirdStr : '') +
        '</div>' +
        '</div>' +
        // '<div class="text-muted text-center font-size-14 mt-3">继续即代表同意<a href="/tos" target="_blank">《服务条款》</a>和<a href="/privacy" target="_blank">《隐私政策》</a>' +
        '</div>' +
        '</div>'
      let thirdpartyStr =
        '<div class="card-body login-block">' +
        '<h3 class="text-center mb-3">' +
        global.title +
        '</h3>' +
        // '<div class="login-nav text-center mb-3">' +
        //     this.thirdpartyregisterTpl().btnStr +
        //     this.thirdpartyconnectTpl().btnStr +
        // '</div>' +
        // this.thirdpartyregisterTpl().formStr +
        this.thirdpartyconnectTpl().formStr +
        '</div>' +
        '</div>' +
        // '<div class="text-muted text-center font-size-14 mt-3">继续即代表同意<a href="/tos" target="_blank">《服务条款》</a>和<a href="/privacy" target="_blank">《隐私政策》</a>' +
        '</div>' +
        '</div>'
      let registerHtml =
        '<div class="card" style="display: none" id="loginDiv">' +
        this.registerTpl().tpl +
        '</div>'
      let loginHtml =
        '<div class="card" style="display: none" id="loginDiv">' +
        loginStr +
        (global.registerStep ? this.registerTpl().tpl : '') +
        '</div>'
      let resetpasswordHtml =
        '<div class="card" style="display: none" id="loginDiv">' +
        this.resetPasswordTpl().formStr +
        '</div>'
      let accountcancelHtml =
        '<div class="card" style="display: none" id="loginDiv">' +
        this.accountCancelTpl().formStr +
        '</div>'
      let thirdpartyHtml =
        '<div class="card" style="display: none" id="loginDiv">' +
        thirdpartyStr +
        '</div>'
      let thirdStrs = `<div class="third-3rd text-center mt-3">
                <ul class="3rd-btn-group mt-3 font-size-20">`
      const thirdConfKeys = global.thirdParty.types
      thirdConfKeys.map((key, index) => {
        const item = thirdConf[key]
        let str = `<li  data-platform="${item.platform}" >
                            <span><i><img src="${item.icon}"/></i><img class="bind-icon ${item.bind ? '' : 'd-none'}" src="/src/img/binding.svg" alt=""></span>
                            <p>${item.bind ? '已绑定' : '未绑定'}</p>
                       </li>`
        thirdStrs += str
      })
      thirdStrs += '</ul></div>'

      let thirdpartyqueryHtml =
        '<div class="card">' +
        thirdStrs +
        '</div>'
      return {
        loginHtml,
        registerHtml,
        resetpasswordHtml,
        accountcancelHtml,
        thirdpartyHtml,
        thirdpartyqueryHtml
      }
    },
    // 初始化登录方式
    initLoginMode: function () {
      var mode = global.defaultMode,
        _self = this,
        modeTypes = ['password', 'no-password', 'weixin'],
        loginModes = 0
      if (!global[mode + 'Show']) {
        // alert('未启用' + mode + '登录模式！')
        toast({
          content:
            setLang('messages', 'notice', 'tip2', 0) +
            mode +
            setLang('messages', 'notice', 'tip2', 1),
          type: 'error',
        })
        return
      } else {
        $('.form.' + mode + '-form').removeClass('d-none')
      }
      for (const item of modeTypes) {
        global[item + 'Show'] && loginModes++
      }
      if (loginModes <= 1) $('.login-nav').addClass('d-none')
      $('.login-mode').each(function (index, item) {
        if ($(this).attr('data-mode') === mode) {
          $(this).addClass('text-body')
        }
      })
      //   mode == 'no-password' && _self.getAuthCode()
      if (mode == 'no-password' || mode == 'thirdconnect') _self.getAuthCode()
      // $('.login-mode').forEach(function(item, index) {
      //   console.log(item, index);
      //   if (item.attr('data-mode') == mode) {
      //     item.addClass('text-body')
      //   }
      // })
    },
    //解绑和绑定第三方
    thirdPartybindFn: function () {
      var _self = this
      $('.third-3rd li').on('click', function () {
        const platformId = $(this).attr('data-platform')
        const _item = global.dataList.filter(item => item.platformId == platformId)[0]
        if (_item) {//解绑
          let accessToken = global.userInforObj.accessToken
          global.unbindInfor = {
            accessToken,
            platformId
          }
          _self.thirdpartyunbindInit(global)
        } else {//绑定
          const area = config.interface.internal
          const envBase = area[global.env]
          location.href =
            envBase.origin +
            area.thirdPartyLogin +
            `?appId=${envBase.appId}&tenantId=${envBase.tenantId}&source=${global.thirdParty.source}&platformId=${platformId}&scopeType=0&from=${global.thirdParty.from}`

        }
      })
    },
    // 登录模式切换
    loginModeChange: function () {
      var _self = this
      // console.log($('.login-mode'));
      $('.login-mode').on('click', function () {
        var mode = $(this).attr('data-mode')
        console.log('--mode-->', mode)
        if (mode === global.currentMode) return false
        global.currentMode = mode
        global.loginType = global.typeSupport ? 'phone' : 'mail'
        console.log(mode, global.loginType)
        $(this).siblings().removeClass('text-body')
        $(this).addClass('text-body')
        $('.form').addClass('d-none')
        $('.form.' + mode + '-form').removeClass('d-none')
        $('.is-invalid').removeClass('is-invalid')
        // if(mode !== 'weixin'&& mode !== 'thirdconnect'&& mode !== 'thirdregister'){
        //     initNECaptchaElement(mode)
        // }
        // if(mode == 'thirdconnect')global.loginType = 'mail'
        mode !== 'weixin' && initNECaptchaElement(mode)
        // if(mode == 'no-password' || mode == 'thirdregister'|| mode == 'thirdconnect')_self.getAuthCode()
        mode == 'no-password' && _self.getAuthCode()
        $('.login-type').text(
          setLang(
            'messages',
            'loginType',
            mode === 'no-password' ? 'mailCode' : 'mailPassword'
          )
        )
        global.typeSupport != 2 ? $('.login-type').hide() : ''; // 2的时候支持切换手机号和邮箱
      })
    },
    //第三方关联方式切换
    thirdTypeChange () {
      $('.btn_thirdConnect').on('click', function () {
        console.log('data-type', global.loginType, $(this).attr('data-type'))
        var type = $(this).attr('data-type')
        if (type === 'accountPassword') {
          global.loginType = 'code'
          $(this).attr('data-type', '')
          $('input[name=password]')
            .parent()
            .addClass('d-none')
          // $('input[name=username]')
          // .parent()
          // .addClass('d-none')
          $('input[name=authCode]')
            .parent()
            .removeClass('d-none')
          //  $('input[name=phone]')
          // .parent()
          // .removeClass('d-none')
          $(this).text(
            setLang('messages', 'notecodeBtn')
          )
        } else {
          global.loginType = 'phone'
          $(this).attr('data-type', 'accountPassword')
          $('input[name=password]')
            .parent()
            .removeClass('d-none')
          // $('input[name=username]')
          // .parent()
          // .removeClass('d-none')
          $('input[name=authCode]')
            .parent()
            .addClass('d-none')
          // $('input[name=phone]')
          // .parent()
          // .addClass('d-none')
          $(this).text(
            setLang('messages', 'accountpasswordBtn')
          )
        }
      })
    },
    // 登录方式切换
    loginTypeChange () {
      $('.login-type').on('click', function () {
        console.log(global.loginType)
        let mode = global.currentMode
        if (global.loginType === 'phone') {
          global.loginType = 'mail'
          $(this).text(
            setLang(
              'messages',
              'loginType',
              mode === 'no-password' ? 'phoneCode' : 'phonePassword'
            )
          )
          $('.' + mode + '-form input[name=phone]')
            .parent()
            .addClass('d-none')
          $('.' + mode + '-form input[name=mail]')
            .parent()
            .removeClass('d-none')
        } else {
          global.loginType = 'phone'
          $(this).text(
            setLang(
              'messages',
              'loginType',
              mode === 'no-password' ? 'mailCode' : 'mailPassword'
            )
          )
          $('.' + mode + '-form input[name=mail]')
            .parent()
            .addClass('d-none')
          $('.' + mode + '-form input[name=phone]')
            .parent()
            .removeClass('d-none')
        }
      })
    },
    // 表单验证通过
    inputBlur () {
      $('.form input').on('blur', function () {
        this.value.trim() !== '' && $(this).removeClass('is-invalid')
      })
    },
    // 验证码验证成功
    captchaBlur () {
      $('#' + global.currentMode + '-captcha').removeClass('is-invalid')
    },
    // 验证码校验结果
    captchaCheck () {
      let captchaRes = true
      let captchaEle = inputEle('captcha')
      if (!captchaIns.validate) {
        if (global.NECaptcha.mode !== 'popup') {
          captchaEle.addClass('is-invalid')
          global.errorColor && captchaEle.css('border-color', global.errorColor)
          // }else{
          //   alert('请完成验证操作！')
        }
        captchaRes = false
      }
      return captchaRes
    },
    // 表单校验
    validator (obj) {
      let valid = true,
        checkObj = {};
      for (let key of obj) {
        if (key === 'captcha') {
          checkObj[key] = this.captchaCheck()
          if (!this.captchaCheck()) {
            valid = false
          }
        } else {
          checkObj[key] = inputEle(key).val()
          if (checkObj[key] === '') {
            inputEle(key).addClass('is-invalid')
            inputEle(key)
              .siblings('.invalid-feedback')
              .text(
                setLang(
                  'messages',
                  key,
                  'username' === key ? accountPlaceholder[global.typeSupport]:'placeholder'
                )
              )
            valid = false
          } else {
            // valid = true
            inputEle(key).removeClass('is-invalid')
            switch (key) {
              case 'phone':
                if (!regObj.phone.test(checkObj[key])) {
                  valid = false
                  inputEle(key).addClass('is-invalid')
                  inputEle(key)
                    .siblings('.invalid-feedback')
                    .text(setLang('messages', key, 'invalid'))
                }
                break
              case 'mail':
                if (!regObj.mail.test(checkObj[key])) {
                  valid = false
                  inputEle(key).addClass('is-invalid')
                  inputEle(key)
                    .siblings('.invalid-feedback')
                    .text(setLang('messages', key, 'invalid'))
                }
                break
              case 'username':
                let reg = [
                  !regObj.mail.test(checkObj[key]),
                  !regObj.phone.test(checkObj[key]),
                  !regObj.phone.test(checkObj[key]) && !regObj.mail.test(checkObj[key])
                ][global.typeSupport];
                if (reg) {
                  valid = false
                  inputEle(key).addClass('is-invalid')
                  inputEle(key)
                    .siblings('.invalid-feedback')
                    .text(
                      setLang(
                        'messages',
                        key,
                        accountInvalid[global.typeSupport]
                      )
                    )
                }
                break
              case 'resg-password':
                console.log(regObj.password.test(checkObj[key]))
                if (!regObj.password.test(checkObj[key])) {
                  valid = false
                  inputEle(key).addClass('is-invalid')
                  inputEle(key)
                    .siblings('.invalid-feedback')
                    .text(setLang('messages', key, 'invalid'))
                }
                break
              case 'confirm-password':
                let pwd = inputEle('resg-password').val(),
                  newPwd = checkObj[key]
                if (pwd != newPwd) {
                  valid = false
                  inputEle(key).addClass('is-invalid')
                  inputEle(key)
                    .siblings('.invalid-feedback')
                    .text(setLang('messages', key, 'invalid'))
                }
                break
              case 'agreement':
                checkObj[key] = inputEle(key).is(':checked')
                if (!checkObj[key]) {
                  valid = false
                  inputEle(key).addClass('is-invalid')
                  inputEle(key)
                    .siblings('.invalid-feedback')
                    .text(setLang('messages', key, 'invalid'))
                }
            }
          }
        }
      }
      console.log(checkObj, valid)
      return valid
    },
    // 获取验证码倒计时
    countDown () {
      let timer
      let time = 60
      let btn = $('#' + global.currentMode + '-getAuthCode')
      let countWarp = btn.siblings('span')
      btn.addClass('d-none')
      countWarp.text(time + 's').removeClass('d-none')
        ; (function () {
          timer = setInterval(() => {
            if (time > 0) {
              time--
              countWarp.text(time + 's')
            } else {
              clearTimeout(timer)
              initNECaptchaElement(global.currentMode)
              btn.removeClass('d-none')
              countWarp.addClass('d-none')
            }
          }, 1000)
        })()
    },
    // 获取短信验证码
    getAuthCode: function () {
      let _self = this
      console.log('--currentMode-->', global.currentMode)
      $('#' + global.currentMode + '-getAuthCode')
        .off()
        .on('click', function () {
          if (_self.clickFlag) {
            return
          }
          _self.clickFlag = true
          let data,
            url,
            compType = global.loginType
          if (['resetpassword', 'register'].includes(global.currentMode)) {
            compType = 'username'
          }
          if (global.loginType == 'code') {
            compType = 'phone'
          }
          data = {
            validate: captchaIns.validate,
          }
          let username = $(
            '.' + global.currentMode + '-form input[name=' + compType + ']'
          ).val()
          if (regObj.phone.test(username)) {
            url = config.interface.internal.sendVerifyCode.sms
            data.mobile = username
          } else if (regObj.mail.test(username)) {
            url = config.interface.internal.sendVerifyCode.mail
            data.email = username
          } else {
          }
          data.lang = global.lang
          switch (global.currentMode) {
            case 'register':
              data.bType = 'REGISTER'
              break
            case 'resetpassword':
              data.bType = 'FIND_PASSWORD'
              break
            default:
              data.bType = 'LOGIN'
              break
          }
          // }
// _self.countDown()
//           return 
          console.log('--compType-->', compType)
          console.log('--data-->', data);
          console.log('rsaDecrypt', rsaDecrypt(rsaEncryptFun(data, 'obj')));
          if (_self.validator([compType, 'captcha'])) {
            onCloseFn = function () {
              _self.ajaxData({
                type: 'POST4',
                url,
                data: rsaEncryptFun(data, 'obj'),
                encrypt: 'encrypt',
                success (res) {
                  _self.countDown()
                  console.log('success---->', res)
                  if (res.status === 'SUCCESS') {
                    toast({
                      content: setLang('messages', 'successMsg', 'send'),
                      type: 'success',
                    })
                  } else {
                    toast({
                      content: res.failCause,
                      type: 'error',
                    })
                  }
                },
                error (err) {
                  // initNECaptchaElement(global.currentMode)
                },
              })
            }
            if (global.NECaptcha.mode === 'popup') {
              initNECaptchaElement(global.currentMode)
              captchaIns && captchaIns.popUp()
            } else {
              debounce(onCloseFn, 1000)()
            }
            setTimeout(() => {
              _self.clickFlag = false
            }, 10000)
          } else {
            _self.clickFlag = false
            toast({
              content: setLang('messages', 'dialog', 'fillInfo'),
              type: 'error',
            })
            // alert({title: setLang('messages', dialog.title,content: setLang('messages', dialog.fillInfo, doneText: setLang('messages', dialog.doneText})
          }
        })
    },
    // 重置密码校验验证码
    resetPwdCheckCode () {
      let _self = this
      $('.btn.next').on('click', function () {
        if (_self.validator(['username', 'authCode'])) {
          if (_self.clickFlag) {
            toast({
              type: 'loading',
            })
            return
          }
          _self.clickFlag = true
          let data = {
            key: rsaEncryptFun(inputEle('username').val()),
            captcha: rsaEncryptFun(inputEle('authCode').val()),
            bType: rsaEncryptFun('FIND_PASSWORD'),
          }
          _self.ajaxData({
            url: config.interface.internal.resetPwdCheckCode,
            type: 'get',
            data,
            encrypt: 'encrypt',
            success (res) {
              console.log(res)
              if (ajaxSuccessCode.includes(res.code)) {
                $('.resetpassword-step1').addClass('d-none')
                $('.resetpassword-step2').removeClass('d-none')
              } else {
                toast({
                  content: res.msg,
                  type: 'error',
                })
              }
            },
            error (err) {
              if (err.readyState !== 0) {
                initNECaptchaElement(global.currentMode)
              }
            },
          })
          setTimeout(() => {
            _self.clickFlag = false
          }, 10000)
          // $('.resetpassword-step1').addClass('d-none')
          // $('.resetpassword-step2').removeClass('d-none')
        }
      })
    },
    // 表单提交
    infoSubmit: function () {
      var _self = this
      if (_self.clickFlag) {
        toast({
          type: 'loading',
        })
        return
      }
      console.log(global.currentMode)
      console.log(captchaIns)
      switch (global.currentMode) {
        case 'password':
          _self.passwordSubmit()
          break
        case 'no-password':
          _self.noPasswordSubmit()
          break
        case 'register':
          _self.registerSubmit()
          break
        case 'thirdregister':
          _self.thirdregisterSubmit()
          break
        case 'thirdconnect':
          _self.thirdconnectSubmit()
          break
        case 'resetpassword':
          _self.resetPasswordSubmit()
          break
        case 'accountcancel':
          _self.accountCancelSubmit()
          break
      }
    },
    // 密码登录提交
    passwordSubmit () {
      let _self = this
      let data, url
      if (
        _self.validator(
          [global.loginType, 'password', 'captcha']
          //   global.errorCount >= 3
          //     ? [global.loginType, 'password', 'captcha']
          //     : [global.loginType, 'password']
        )
      ) {
        onCloseFn = function () {
          if (_self.clickFlag) {
            toast({
              type: 'loading',
            })
            return
          }
          _self.clickFlag = true
          // _self.captchaCheck() &&
          console.log(global)
          let username = inputEle(global.loginType).val() //inputEle('username').val()
          console.info('$.md5', $)
          let password = $.md5(inputEle('password').val())
          // if(global.lang !== 'zh-CN'){  // 海外
          //   url = config.interface.oversea.login
          //   data = {
          //     "username": '+86' + $('.' + global.currentMode + '-form input[name=phone]').val() ,//"test22334455@tcl.com",
          //     password,
          //     "channel": "app",
          //     "captchaRule":3,
          //     "validate":captchaIns.validate,
          //   }
          // } else { //国内
          url = config.interface.internal.login
          data = {
            username, // '13100000001', //"test22334455@tcl.com",
            password, //'4297f44b13955235245b2497399d7a93aa', //"4297F44B13955235245B2497399D7A93",
            channel: 'app',
            captchaRule: 3,
            validate: captchaIns.validate,
          }
          // }
          console.log(data)
          //   global.errorCount >= 3 && (data.validate = captchaIns.validate)
          _self.ajaxData({
            type: 'POST4',
            url,
            data: rsaEncryptFun(data, 'obj'),
            encrypt: 'encrypt',
            success (res) {
              console.log(res)
              initNECaptchaElement(global.currentMode)
              if (!ajaxSuccessCode.includes(res.code)) {
                // if (res.errorCount >= 3) {
                //   initNECaptchaElement(global.currentMode)
                //   $('#password-captcha').parent().removeClass('d-none')
                // }
                // if (res.errorCode == 'EC102401006') {
                //   initNECaptchaElement(global.currentMode)
                //   $('#password-captcha').parent().addClass('d-none')
                // }
                //
                global.errorCount = res.errorCount
                toast({
                  content: setLang('messages', 'errorMsg', res.errorCode),
                  type: 'error',
                })
              } else {
                res.data = decodeToken(res.accessToken)
                _self.result = {
                  ...res,
                }
                toast({
                  content: setLang('messages', 'successMsg', 'login'),
                  type: 'success',
                })
                _self.successNext()
              }
            },
            error (err) {
              initNECaptchaElement(global.currentMode)
            },
          })
          setTimeout(() => {
            _self.clickFlag = false
          }, 10000)
        }
        // if (global.errorCount >= 3 && global.NECaptcha.mode === 'popup') {
        if (global.NECaptcha.mode === 'popup') {
          initNECaptchaElement(global.currentMode)
          captchaIns && captchaIns.popUp()
        } else {
          onCloseFn()
        }
      }
    },
    // 免密码（验证码）登录提交
    noPasswordSubmit () {
      let _self = this
      let data, url
      if (_self.validator([global.loginType, 'authCode', 'captcha'])) {
        if (_self.clickFlag) {
          toast({
            type: 'loading',
          })
          return
        }
        _self.clickFlag = true
        let username = inputEle(global.loginType).val()
        let authCode = inputEle('authCode').val()
        // if(global.lang !== 'zh-CN'){  // 海外
        //   url = config.interface.oversea.quickLogin
        //   data = {
        //     username,
        //     "code": authCode, //"888888",
        //     // "validate":captchaIns.validate,
        //     "channel": "app",
        //   }
        // } else { //国内
        url = config.interface.internal.quickLogin
        data = {
          username, // '13100000001', //"test22334455@tcl.com",
          validCode: authCode, //'4297f44b13955235245b2497399d7a93aa', //"4297F44B13955235245B2497399D7A93",
          bType: 'LOGIN',
        }
        // }
        _self.clickFlag = true
        _self.ajaxData({
          type: 'POST4',
          url,
          data: rsaEncryptFun(data, 'obj'),
          encrypt: 'encrypt',
          success (res) {
            console.log(res)
            initNECaptchaElement(global.currentMode)
            if (ajaxSuccessCode.includes(res.code)) {
              res.data = decodeToken(res.accessToken)
              _self.result = {
                ...res,
              }
              _self.successNext()
              toast({
                content: setLang('messages', 'successMsg', 'login'),
                type: 'success',
              })
            } else {
              if (res.msg === '未找到用户信息!') {
                confirm({
                  title: setLang('messages', 'dialog', 'title'),
                  content: setLang('messages', 'dialog', 'registerTip'),
                  doneText: setLang('messages', 'dialog', 'doneTextRegister'),
                  cancelText: setLang('messages', 'dialog', 'cancalText'),
                })
                  .then(() => {
                    console.log('确认')
                    window.location.href = global.registerLink
                  })
                  .catch(() => {
                    console.log('已取消')
                  })
              } else {
                toast({
                  content: setLang('messages', 'errorMsg', res.errorCode),
                  type: 'error',
                })
              }
            }
          },
          error (err) {
            if (err.readyState !== 0) {
              initNECaptchaElement(global.currentMode)
            }
          },
        })
        setTimeout(() => {
          _self.clickFlag = false
        }, 10000)
      }
    },
    //第三方关联账号提交
    thirdconnectSubmit () {
      let _self = this
      console.log('global.loginType', global.loginType)
      let data, url
      let validArr = [
        // global.loginType == 'phone'?'username':'phone',
        'phone',
        global.loginType == 'phone' ? 'password' : 'authCode',
        global.loginType == 'phone' ? 'captcha' : ''
      ]
      //linkParams
      validArr = validArr.filter(item => item)
      if (_self.validator(validArr) && global.linkParams) {
        let data = {},
          url;
        let { platformId, thirdPartyId, unionId } = global.linkParams
        data = {
          platformId,
          thirdPartyId,
          unionId
        }
        if (global.loginType == 'phone') {
          //   data.username = inputEle('username').val()
          data.username = inputEle('phone').val()
          data.password = $.md5(inputEle('password').val())
          url = config.interface.internal.thirdPartyBindByUser
        } else {
          data.username = inputEle('phone').val()
          data.code = inputEle('authCode').val()
          url = config.interface.internal.thirdPartyBindByValid
        }
        // if (regObj.phone.test(data.username)) {
        //   data.type = 3
        // } else if (regObj.mail.test(data.username)) {
        //   data.type = 2
        // }
        console.log('data', data)
        _self.ajaxData({
          type: 'POST1',
          url,
          data,
          success (res) {
            _self.clickFlag = false
            if (ajaxSuccessCode.includes(res.code)) {
              alert({
                title: setLang('messages', 'dialog', 'title'),
                content: setLang('messages', 'successMsg', 'connect'),
                doneText: setLang('messages', 'dialog', 'doneText'),
              })
              inputEle('authCode').val('')
              _self.result = {
                ...res,
              }
              _self.successNext()
            } else {
              initNECaptchaElement(global.currentMode)
              inputEle('authCode').val('')
              toast({
                content: setLang('messages', 'errorMsg', res.errorCode + ''),
                type: 'error',
              })
            }
          },
          error (err) { }
        })
      }
    },
    //第三方注册提交
    thirdregisterSubmit () {
      let _self = this
      let data, url
      let validArr = [
        'phone',
        'authCode',
        'resg-password',
        'confirm-password',
      ]
      if (_self.validator(validArr)) {
        _self.clickFlag = true
        let username = inputEle('username').val()
        let code = inputEle('authCode').val()
        let password = $.md5(inputEle('resg-password').val())
        if (regObj.phone.test(username)) {
          type = 3
        } else if (regObj.mail.test(username)) {
          type = 2
        }
        url = config.interface.internal.thirdPartyBind
        data = {
          username, // '13100000001', //"test22334455@tcl.com",
          code,
          password,
          type,
          bType: 'REGISTER',
          channel: 'web',
        }
        _self.ajaxData({
          url,
          data,
          success (res) { },
          error (err) { }
        })
      }
    },
    // 注册提交
    registerSubmit () {
      let _self = this
      let data, url
      let validArr = [
        'username',
        'authCode',
        'resg-password',
        'confirm-password',
      ]
      global.agreementShow && validArr.push('agreement')
      if (_self.validator(validArr)) {
        _self.clickFlag = true
        let username = inputEle('username').val()
        let code = inputEle('authCode').val()
        let password = $.md5(inputEle('resg-password').val())
        let type
        if (regObj.phone.test(username)) {
          type = 3
        } else if (regObj.mail.test(username)) {
          type = 2
        }
        // if(global.lang !== 'zh-CN'){  // 海外
        //   url = config.interface.oversea.quickRegister
        //   data = {
        //     username,
        //     code, //"888888",
        //     // "validate":captchaIns.validate,
        //     "channel": "app",
        //   }
        // } else { //国内
        url = config.interface.internal.registerNoCaptcha
        data = {
          username, // '13100000001', //"test22334455@tcl.com",
          code,
          password,
          type,
          bType: 'REGISTER',
          channel: 'web',
        }

        // }
        _self.ajaxData({
          type: 'POST4',
          url,
          data: rsaEncryptFun(data, 'obj'),
          encrypt: 'encrypt',
          success (res) {
            _self.clickFlag = false
            console.log(res)
            if (ajaxSuccessCode.includes(res.code)) {
              alert({
                title: setLang('messages', 'dialog', 'title'),
                content: setLang('messages', 'successMsg', 'register'),
                doneText: setLang('messages', 'dialog', 'doneText'),
              }).then(() => {
                window.location.href = global.loginLink
              })
            } else {
              initNECaptchaElement(global.currentMode)
              inputEle('authCode').val('')
              toast({
                content: setLang('messages', 'errorMsg', res.errorCode + ''),
                type: 'error',
              })
            }
          },
          error (err) {
            // _self.clickFlag = false
            if (err.readyState !== 0) {
              initNECaptchaElement(global.currentMode)
            }
            // console.log(err)
          },
        })
        setTimeout(() => {
          _self.clickFlag = false
        }, 10000)
      }
    },
    // 重置密码提交
    resetPasswordSubmit () {
      let _self = this
      if (
        _self.validator([
          'username',
          'authCode',
          'resg-password',
          'confirm-password',
        ])
      ) {
        _self.clickFlag = true
        let username = inputEle('username').val(),
          password = $.md5(inputEle('confirm-password').val())
        let data = {
          username,
          safeCode: inputEle('authCode').val(),
          newPassword: password,
          isPwdMd5: 'Y',
          canSame: 'N',
        }
        _self.ajaxData({
          url: config.interface.internal.updatePwd,
          type: 'POST4',
          data: rsaEncryptFun(data, 'obj'),
          encrypt: 'encrypt',
          success (res) {
            _self.clickFlag = false
            console.log(res)
            if (ajaxSuccessCode.includes(res.code)) {
              //   confirm({
              //     title: setLang('messages', 'dialog', 'title'),
              //     content: res.msg,
              //     doneText: setLang('messages', 'dialog', 'doneTextLogin'),
              //     cancelText: setLang('messages', 'dialog', 'doneText'),
              //   })
              //     .then(() => {
              //       console.log('已确认')
              //       _self.ajaxData({
              //         url: config.interface.internal.login,
              //         data: {
              //           username, // '13100000001', //"test22334455@tcl.com",
              //           password, //'4297f44b13955235245b2497399d7a93aa', //"4297F44B13955235245B2497399D7A93",
              //           channel: 'app',
              //           captchaRule: 3,
              //         },
              //         success(res) {
              //           console.log(res)
              //           if (!ajaxSuccessCode.includes(res.code)) {
              //             toast({
              //               content: setLang(
              //                 'messages',
              //                 'errorMsg',
              //                 res.errorCode + ''
              //               ),
              //               type: 'error',
              //             })
              //           } else {
              //             res.data = decodeToken(res.accessToken)
              //             _self.result = { ...res }
              //             _self.successNext()
              //             toast({
              //               content: setLang('messages', 'successMsg', 'reset'),
              //               type: 'success',
              //             })
              //           }
              //         },
              //         error(err) {
              //           alert(err)
              //         },
              //       })
              //     })
              //     .catch(() => {
              //       console.log('已取消')
              //       window.location.href = global.loginLink
              //     })
              alert({
                title: setLang('messages', 'dialog', 'title'),
                content: setLang('messages', 'successMsg', 'reset'),
                doneText: setLang('messages', 'dialog', 'doneText'),
              }).then(() => {
                window.location.href = global.loginLink
              })
            } else {
              toast({
                content: setLang('messages', 'errorMsg', res.errorCode + ''),
                type: 'error',
              })
            }
          },
          error (err) {
            _self.clickFlag = false
            initNECaptchaElement(global.currentMode)
            console.log(err)
          },
        })
        setTimeout(() => {
          _self.clickFlag = false
        }, 10000)
        // $('.resetpassword-step1').addClass('d-none')
        // $('.resetpassword-step2').removeClass('d-none')
      }
    },
    // 账号注销提交
    accountCancelSubmit () {
      let _self = this
      if (_self.validator(['username', 'password', 'captcha'])) {
        _self.clickFlag = true
        let username = inputEle('username').val(),
          password = $.md5(inputEle('password').val())
        let data = {
          username,
          password,
          validate: captchaIns.validate,
        }
        _self.ajaxData({
          type: 'POST4',
          url: config.interface.internal.deleteByPassword,
          data: rsaEncryptFun(data, 'obj'),
          encrypt: 'encrypt',
          success (res) {
            _self.clickFlag = false
            _self.result = {
              ...res,
            }
            _self.successNext()
            if (ajaxSuccessCode.includes(res.code)) {
              toast({
                content: setLang('messages', 'successMsg', 'cancel'),
                type: 'success',
              })
            } else {
              toast({
                content: setLang('messages', 'errorMsg', res.errorCode + ''),
                type: 'error',
              })
            }
          },
          error (err) {
            _self.clickFlag = false
            initNECaptchaElement(global.currentMode)
            console.log(err)
          },
        })
        setTimeout(() => {
          _self.clickFlag = false
        }, 10000)
      }
    },
    thirdpartyloginInit: function name (params) {
      console.log('config', config)
      console.log('params', params)
      let _self = this,
        url = config.interface.internal.bindThirdParty
      let data = params.bindInfor
      data &&
        _self.ajaxData({
          type: 'POST3',
          url: url,
          data,
          success (res) {
            if (ajaxSuccessCode.includes(res.status)) {
              //   toast({
              //     content: setLang('messages', 'successMsg', 'logout'),
              //     type: 'success',
              //   })
              _self.result = {
                ...res,
              }
              _self.successNext()
              location.reload();
            } else {
              //   toast({
              //     content: setLang('messages', 'errorMsg', res.errorCode + ''),
              //     type: 'error',
              //   })
            }
          },
          error (err) {
            console.log(err)
          },
        })
      setTimeout(() => {
        _self.clickFlag = false
      }, 10000)
    },
    thirdpartyunbindInit: function (params) {
      console.log('config', config)
      console.log('params', params)
      let _self = this,
        url = config.interface.internal.unbindThirdParty
      let data = params.unbindInfor
      data &&
        _self.ajaxData({
          type: 'POST2',
          url: url,
          data,
          success (res) {
            if (ajaxSuccessCode.includes(res.status)) {
              //   toast({
              //     content: setLang('messages', 'successMsg', 'logout'),
              //     type: 'success',
              //   })
              _self.result = {
                ...res,
              }
              _self.successNext()
              location.reload();
            } else {
              //   toast({
              //     content: setLang('messages', 'errorMsg', res.errorCode + ''),
              //     type: 'error',
              //   })
            }
          },
          error (err) {
            console.log(err)
          },
        })
      setTimeout(() => {
        _self.clickFlag = false
      }, 10000)
    },
    //获取第三方关联信息
    thirdpartyquery: function (params) {
      console.log('config', config)
      console.log('params', params)
      let _self = this,
        url = config.interface.internal.queryThirdPartyInfos
      if (_self.clickFlag) {
        toast({
          type: 'loading',
        })
        return
      }
      _self.clickFlag = true
      let accountId = params.userInforObj.accountId
      accountId &&
        _self.ajaxData({
          type: 'get',
          url: url,
          accountId,
          success (res) {
            _self.clickFlag = true
            if (ajaxSuccessCode.includes(res.code)) {
              //   toast({
              //     content: setLang('messages', 'successMsg', 'logout'),
              //     type: 'success',
              //   })
              _self.result = {
                ...res,
              }
              _self.successNext()
              global = deepObjectMerge(global, res)
              _self.thirdpartyqueryInit()
            } else {
              toast({
                content: setLang('messages', 'errorMsg', res.errorCode + ''),
                type: 'error',
              })
            }
          },
          error (err) {
            _self.clickFlag = false
            console.log(err)
          },
        })
      setTimeout(() => {
        _self.clickFlag = false
      }, 10000)
    },
    //注销token退出
    logOutSubmit: function (params) {
      console.log('config', config)
      console.log('params', params)
      let _self = this,
        url = config.interface.internal.logout
      if (_self.clickFlag) {
        toast({
          type: 'loading',
        })
        return
      }
      _self.clickFlag = true
      let { username, accessToken } = params.logoutObj
      let data = {
        username,
        accessToken
      }
      data &&
        _self.ajaxData({
          type: 'POST4',
          url,
          data: rsaEncryptFun(data, 'obj'),
          encrypt: 'encrypt',
          success (res) {
            _self.clickFlag = true
            if (ajaxSuccessCode.includes(res.code)) {
              toast({
                content: setLang('messages', 'successMsg', 'logout'),
                type: 'success',
              })
              _self.result = {
                ...res,
              }
              _self.successNext()
            } else {
              toast({
                content: setLang('messages', 'errorMsg', res.errorCode + ''),
                type: 'error',
              })
            }
          },
          error (err) {
            _self.clickFlag = false
            console.log(err)
          },
        })
      setTimeout(() => {
        _self.clickFlag = false
      }, 10000)
    },
    //校验token
    tokenCheckSubmit: function (params) {
      console.log('config', config)
      console.log('params', params)
      let _self = this,
        url = config.interface.internal.validateToken
      let accessTokens = params.accessToken
      accessTokens &&
        _self.ajaxData({
          type: 'get',
          url: url,
          encrypt: 'encrypt',
          accessToken: accessTokens,
          success (res) {
            _self.result = {
              ...res,
            }
            _self.successNext()
            //   if (ajaxSuccessCode.includes(res.code)) {
            //     toast({
            //         content: setLang('messages', 'successMsg', 'validateSuccess'),
            //         type: 'success',
            //     })
            //     _self.result = { ...res }
            //     _self.successNext()
            //   }else{
            //     toast({
            //         content: setLang('messages', 'errorMsg', res.errorCode + ''),
            //         type: 'error',
            //     })
            //     window.location.href = global.loginLink
            //   }
          },
          error (err) {
            console.log(err)
          },
        })
    },
    // 登录成功后续操作
    successNext: function () {
      var _self = this
      console.log('.result', _self.result)
      if (global.registerStep) {
        $('.login-block').addClass('d-none')
        $('.register-block').removeClass('d-none')
      } else {
        //   console.log(global.onSuccess)
        typeof global.onSuccess === 'function' && global.onSuccess(_self.result)
      }
    },
    ajaxData (params) {
      let _self = this
      let {
        url,
        type = 'POST',
        data = {},
        success,
        error,
        accessToken = '',
        accountId = '',
        encrypt
      } = params
      let area
      area = config.interface.internal;
      let appId = global.appId
      let tenantId = !params.only && global.tenantId
      let appSecret = !params.only && global.appSecret

      // if (!params.only) {
      //   console.log(`ajaxData------------appId：${appId}, tenantId：${tenantId},  appSecret：${appSecret}`);
      // } else {
      //   console.log(`ajaxData------------appId：${appId}`);
      // }

      switch (type) {
        case 'POST1':
          data = { ...data, appId, tenantId, appSecret }
          const infor = JSON.parse(JSON.stringify(data))
          const sign = paramsSign(infor)
          data.sign = sign
          url = area[global.env].origin + url
          type = 'POST'
          break;
        case 'POST2':
          url = area[global.env].origin + url + '?accessToken=' + data.accessToken + '&platformId=' + data.platformId
          type = 'POST'
          data = {}
          break;
        case 'POST3':
          data = { ...data, appId, tenantId, appSecret }
          console.log('---infordata-->', data)
          url = area[global.env].origin + url
          type = 'POST'
          break;
        case 'POST4':
          url = area[global.env].origin + url + '?appId=' + rsaEncryptFun(appId, 'str') + '&tenantId=' + rsaEncryptFun(tenantId, 'str') + '&appSecret=' + rsaEncryptFun(appSecret, 'str') +
            (data.lang ? '&language=' + (global.lang == 'en' ? 'en' : 'zh') : '')
          type = 'POST'
          console.log('post4');
          console.log(url);
          break;
        case 'GET1':
          url = area[global.env].origin + url + '?appId=' + appId + '&tenantId=' + tenantId + '&appSecret=' + appSecret + (data.lang ? '&language=' + (global.lang == 'en' ? 'en' : 'zh') : '')
          type = 'get'
          break;
        default:
          url = area[global.env].origin + url + '?appId=' + rsaEncryptFun(appId, 'str') + '&tenantId=' + rsaEncryptFun(tenantId, 'str') + '&appSecret=' + rsaEncryptFun(appSecret, 'str') +
            (data.lang ? '&language=' + (global.lang == 'en' ? 'en' : 'zh') : '')
          console.log('正常url输出', url);

          if (accessToken) {
            alert('accessToken')
            url = url + '&accessToken=' + accessToken
          }
          if (accountId) {
            url = url + '&accountId=' + accountId
          }
          data.lang && delete data.lang

          break;
      }
      try {
        $.ajax({
          type: type,
          dataType: 'json',
          url: url,
          // beforeSend: function(xhr){xhr.setRequestHeader('clientId', '99999999');},//这里设置header
          beforeSend: function (request) {
            if (encrypt) {
              request.setRequestHeader("EncryptVersion", '2.0');
              request.setRequestHeader("Encrypt", 'true');
              request.setRequestHeader("Content-Type", 'application/json;charset=utf-8');
              // request.setRequestHeader('Access-Control-Allow-Origin', '*');
              // request.setRequestHeader('Access-Control-Allow-Headers', 'X-Requested-With');
            } else {
              request.setRequestHeader("Content-Type", 'application/json;charset=UTF-8');
            }
          },
          contentType: 'application/json;charset=UTF-8',
          data: type == 'get' ? data : Object.keys(data).length > 0 ? JSON.stringify(data) : {},
          success: function (res) {
            _self.clickFlag = false
            typeof success === 'function' && success(res)
          },
          error: function (err) {
            console.log('ajax error', err)
            _self.clickFlag = false
            err.statusText !== 'parsererror' && toast({
              type: 'error',
              content:
                err.readyState == 0
                  ? setLang('messages', 'errorMsg', 'NETERROR')
                  : err.statusText,
            })
            typeof error === 'function' && error(err)
            // window.location.href = window.location.href
          },
        })
      } catch (error) {
        console.log('catch error', error)
        _self.clickFlag = false
        toast({
          type: 'error',
          content: error.message,
        })
      }
    },
    // 初始化输入框尺寸
    initInputSize () {
      switch (global.inputsize) {
        case 'small':
          $('.' + global.currentMode + '-form .form-control').addClass(
            'form-control-sm'
          )
          $('.' + global.currentMode + '-form .btn').addClass('btn-sm')
          break
        case 'large':
          $('.' + global.currentMode + '-form .form-control').addClass(
            'form-control-lg'
          )
          $('.' + global.currentMode + '-form .btn').addClass('btn-lg')
          break
        default:
          break
      }
    },
    // 密码框输入字符显隐
    passwordEye () {
      $('.password-eye').on('click', function () {
        if ($(this).hasClass('off')) {
          $(this)
            .removeClass('off')
            .addClass('on')
            .siblings('input.form-control')
            .attr('type', 'text')
        } else {
          $(this)
            .removeClass('on')
            .addClass('off')
            .siblings('input.form-control')
            .attr('type', 'password')
        }
      })
    },
    // 协议点击事件
    agreementHandle () {
      // 隐私协议
      $('a.privacy-agreement').on('click', function () {
        let url = global.env
          ? config.interface.internal[global.env].origin +
          '/auth/agreement-privacy.html'
          : '/test/agreement-privacy.html'
        $.get(url, function (res) {
          alert({
            title: 'TCL 用户隐私政策',
            content: res,
            doneText: '确定',
          }).then(() => {
            console.log('关闭')
          })
          $('.ui__alert_content.in').height('90%')
        })
      })
      // 注册协议
      $('a.register-agreement').on('click', function () {
        let url = global.env
          ? config.interface.internal[global.env].origin +
          '/auth/agreement-register.html'
          : '/test/agreement-register.html'
        $.get(url, function (res) {
          alert({
            title: 'TCL 账户注册协议',
            content: res,
            doneText: '确定',
          }).then(() => {
            console.log('关闭')
          })
          $('.ui__alert_content.in').height('90%')
        })
      })
    },
    // 第三方登录方式按钮点击
    thirdPartyClick () {
      $('.login-3rd').on('click', 'a', function () {
        const platformId = $(this).data('platform')
        console.log(platformId)
        const area = config.interface.internal
        const envBase = area[global.env]
        location.href =
          envBase.origin +
          area.thirdPartyLogin +
          `?appId=${envBase.appId}&tenantId=${envBase.tenantId}&source=${global.thirdParty.source}&platformId=${platformId}&scopeType=0&from=${global.thirdParty.from}`
      })
    },
    md5Init () {
      $.extend({
        md5,
      })
    },
    getPublicKey () {
      const ls = new Storage()
      let _self = this;
      let publicKey = ls.get(`${global.env}-publicKey`)
      !publicKey &&
        _self.ajaxData({
          type: 'GET1',
          url: config.interface.internal.publicKey,
          success (res) {
            console.log(res);
            // global.
          },
          error (err) {
            console.log(err)
            global.publicKey = err.responseText
            console.log(global)
            // 设置公钥 保存时间：1个星期
            ls.set(`${global.env}-publicKey`, `${global.publicKey}`, 60 * 60 * 24 * 7 * 1000);
          },
        })
    }
  }

  var Account = new AccountComp()

  function initComp (type, params) { //除掉易盾初始化
    //  console.log(type,'type',params)
    global = Object.assign(global, params)
    loadScript(config.jQueryURL, function () {
      initEnvMsg(params)
      setTimeout(() => {
        Account[type](params)
        Account.md5Init()
      }, 500);
    })
    let env = config.interface.internal[global.env]
    if (env && env.origin) {
      config.resourceURL = env.origin
    } else {
      config.resourceURL = ''
      config.resourceDIR = '/auth/dist/' // '/dist/' //
    }
  }
  /**
   *当调用组件时初始化判断jq是否存在时执行，及加载样式
   */
  function callComp (type, params) {
    console.log(type, '<---type---,---callComp传入定义参数--->', params)
    initEnvMsg(params); // 修复iot退出登录之后，回到登录页面tenantId和appSecret丢失问题
    try {
      Account[type](params)
      loadScript(config.NECaptchaURL, function () {
        // 进行初始化验证码等后续逻辑
        global &&
          global.defaultMode !== 'weixin' &&
          initNECaptchaElement(global.defaultMode)
      })
    } catch (e) {
      // console.log(e)
      // console.log(typeof e, e.name)
      // console.log(e.message)
      // 加载JQ或者Zepto后执行
      e.name === 'ReferenceError' &&
        e.message.includes('$') &&
        loadScript(config.jQueryURL, function () {
          loadScript(config.jsencryptURL)
          setTimeout(() => {
            loadScript(config.NECaptchaURL, function () {
              console.log('NECaptchaURL---catch---global', global);
              // 进行初始化验证码等后续逻辑
              Account[type](params)
              global &&
                global.defaultMode !== 'weixin' &&
                initNECaptchaElement(global.defaultMode)
            })
          }, 500);
        })
    }

    let env = config.interface.internal[global.env]
    if (env && env.origin) {
      config.resourceURL = env.origin
    } else {
      config.resourceURL = ''
      config.resourceDIR = '/auth/dist/' // '/dist/' //
    }
    console.log('---config--->', config)
    loadStyle(
      config.resourceURL + config.resourceDIR + config.styleFile,
      function () {
        setTimeout(() => {
          $('#account-loading').hide()
          $('#loginDiv').show()
        }, 1000)
      }
    )
  }

  /**
   *匹配对应的 AppId 返回对应的 appSecret tenantId
   */
  function initEnvMsg (params) {
    console.log('initEnvMsgparams', params);
    if (params && params.appId) {
      // 请求切口的前提
      // let url = config.interface.internal.getEnvInfo
      // console.log('initEnvMsg--------function-----Account',Account);
      // Account.ajaxData({
      //   url,
      //   only: 'only',
      //   appId: params.appId,
      //   success (res) {
      //     // initNECaptchaElement(global.currentMode)
      //     const area = config.envInfoList
      //     let appArr = area.filter((item) => {
      //       return item.appId === params.appId
      //     })[0]
      //     console.log(appArr);
      //     console.log('successArrappArr');
      //     global.appId = appArr.appId
      //     global.tenantId = appArr.tenantId
      //     global.appSecret = appArr.appSecret
      //   },
      //   error (err) {
      //     // initNECaptchaElement(global.currentMode)
      //     const area = config.envInfoList
      //     let appArr = area.filter((item) => {
      //       return item.appId === params.appId
      //     })[0]
      //     console.log('initEnvMsg------error----appArr',appArr);
      //     console.log(global);
      //     global.appId = appArr.appId
      //     global.tenantId = appArr.tenantId
      //     global.appSecret = appArr.appSecret
      //   },
      // })


      // 暂时调用本地数据
      const area = config.envInfoList
      let appArr = area.filter((item) => {
        return item.appId === params.appId
      })[0]
      global.appId = appArr.appId
      global.tenantId = appArr.tenantId
      global.appSecret = appArr.appSecret
      console.log(`initEnvMsg--global,--------appId：${global.appId}, tenantId：${global.tenantId},  appSecret：${global.appSecret}`);
    } else {
      toast({
        content: setLang('messages', 'notice', 'tip4'),
        type: 'error',
      })
    }
  }

  // 注册全局组件调用名称
  window.AccountInit = {
    Login: function (params) {
      callComp('loginInit', params)
    },
    Logout: function (params) {
      initComp('logoutInit', params)
    },
    TokenCheck: function (params) {
      initComp('tokenCheckSubmit', params)
    },
    Register: function (params) {
      callComp('regsiterInit', params)
    },
    Resetpassword (params) {
      callComp('resetpasswordInit', params)
    },
    Accountcancel (params) {
      console.log(params);
      callComp('accountcancelInit', params)
    },
    Thirdparty: function (params) {
      callComp('thirdpartyInit', params)
    },
    ThirdpartyQuery: function (params) {
      initComp('thirdpartyquery', params)
    },
    ThirdpartyUnbind: function (params) {
      initComp('thirdpartyunbindInit', params)
    },
    ThirdPartyloginBind: function (params) {
      initComp('thirdpartyloginInit', params)
    },
    DecodeUrlparse: function (params) {
      urlParse('thirdloginFn', params)
    }
  }
  return AccountInit
})
function urlParse (type, callback) {//解析url
  let detail;
  switch (type) {
    case 'thirdloginFn':
      let urlP = decodeURIComponent(location.search.substr(1).replace('detail=', ''))
      urlP = urlP.replace(/\"accountId\":(\d+)/g, '"accountId": "$1"')
      // if(!urlP)return false;
      detail = JSON.parse(urlP || '{}')
      break;

    default:
      break;
  }
  console.log(detail)
  typeof callback === 'function' && callback(detail)
}

/**
 * 根据传入的参数设置相应多语言内容
 * @param {*} rest
 */
function setLang (...rest) {
  // console.log(rest);
  let txt = i18nData[global.lang]
  // let txt =  rest.reduce(function(total= '', cur){
  //   console.log(total, cur);
  //   // s = s[total]
  //   // console.log(s);
  //   total = s[cur]

  //   console.log(total);
  //   return total
  // });
  // 循环
  // for (let index = 0; index < rest.length; index++) {
  //   const element = rest[index];
  //   txt = txt[element]
  // }
  var f = (arr) => {
    arr.map((el) => {
      txt = txt[el]
    })
    return txt
  }
  // 递归
  // var f = (arr) => {
  //   if (arr.length) {
  //     txt = txt[arr.shift()]
  //     f(arr)
  //   }
  //   return txt
  // }
  // reduce
  // var f = (arr) => {
  //   let res
  //   if(arr.length > 1){
  //     arr.reduce((pre, cur)=>{
  //       // console.log(pre, cur);
  //       txt = txt[pre]
  //       res = cur ? txt[cur] : txt
  //       return cur
  //     })
  //   }else{
  //     res = txt[arr[0]]
  //   }
  //   return res
  // }
  return f(rest) // txt
}
/**
 *登录token解码用户信息
 * @param {*} token
 */
function decodeToken (token) {
  const str = decodeURIComponent(escape(window.atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))))
  const data = JSON.parse(str)
  const userInfo = JSON.parse(
    data.userInfo.replace(/\"accountId\":(\d+)/, '"accountId": "$1"')
  )
  console.log(userInfo);
  return userInfo
}
/**
 *字符串转16进制
 * @param {*} str
 * @return {*}
 */
function strToHexCharCode (str) {
  if (str === '') return ''
  var hexCharCode = []
  hexCharCode.push('0x')
  for (var i = 0; i < str.length; i++) {
    hexCharCode.push(str.charCodeAt(i).toString(16))
  }
  return hexCharCode.join('')
}
/**
 * 如果target(也就是FirstOBJ[key])存在，
 * 且是对象的话再去调用deepObjectMerge，
 * 否则就是FirstOBJ[key]里面没这个对象，需要与SecondOBJ[key]合并
 */
function deepObjectMerge (FirstOBJ, SecondOBJ) { // 深度合并对象
  for (var key in SecondOBJ) {
    FirstOBJ[key] = FirstOBJ[key] && FirstOBJ[key].toString() === "[object Object]" ?
      deepObjectMerge(FirstOBJ[key], SecondOBJ[key]) : FirstOBJ[key] = SecondOBJ[key];
  }
  return FirstOBJ;
}
/**
 *  对参数对象按key首字母排序
 * @param {*} params
 */
function sortParams (params) {
  let keys = Object.keys(params).sort()
  let parmasArr = [];
  keys.map(key => parmasArr.push(`${key}=${params[key]}`))
  let parmasURI = parmasArr.join('&')
  return parmasURI
}
/**
 * 接口参数加密签名验证
 * @param {*} params
 */
function paramsSign (params) {
  let sign = sortParams(params)
  sign += global.publicKey
  sign = md5(sign)
  // console.log(sign);
  // sign = strToHexCharCode(sign)
  return sign
}

// 设置、读取 localStorage 的值
class Storage {
  constructor(props) {
    this.props = props || {}
    this.source = this.props.source || window.localStorage
    this.initRun();
  }
  initRun () {
    /*
    * set 存储方法
    * @ param {String}     key 键
    * @ param {String}     value 值，存储的值可能是数组/对象，不能直接存储，需要转换 JSON.stringify
    * @ param {String}     expired 过期时间，以分钟为单位
    */
    const reg = new RegExp("__expires__");
    let data = this.source;
    let list = Object.keys(data);
    if (list.length > 0) {
      list.map((key, v) => {
        if (!reg.test(key)) {
          let now = Date.now();
          let expires = data[`${key}__expires__`] || Date.now + 1;
          if (now >= expires) {
            this.remove(key);
          };
        };
        return key;
      });
    };
  }
  set (key, value, expired) {
    /*
    * set 存储方法
    * @ param {String}     key 键
    * @ param {String}     value 值，
    * @ param {String}     expired 过期时间，以毫秒为单位，非必须
    */
    let source = this.source;
    source[key] = JSON.stringify(value);
    if (expired) {
      source[`${key}__expires__`] = Date.now() + expired
    };
    return value;
  }
  get (key) {
    /*
    * get 获取方法
    * @ param {String}     key 键
    * @ param {String}     expired 存储时为非必须字段，所以有可能取不到，默认为 Date.now+1
    */
    const source = this.source,
      expired = source[`${key}__expires__`] || Date.now + 1;
    const now = Date.now();

    if (now >= expired) {
      this.remove(key);
      return;
    }
    const value = source[key] ? JSON.parse(source[key]) : source[key];
    return value;
  }
  remove (key) {
    const data = this.source,
      value = data[key];
    delete data[key];
    delete data[`${key}__expires__`];
    return value;
  }
}
// let const = new Storage();



// /**
//  * 接口参数密钥加密,需替换 url 的 =（等号）
//  * @param {*} params
//  */
// function rsaEncryptRep (params, type) {
//   let const = new Storage();
//   console.log(type);
//   var encrypt = new JSEncrypt();
//   let publicKey = ls.get(`${global.env}-publicKey`)
//   publicKey && encrypt.setPublicKey(publicKey);
//   let passText = encrypt.encryptLong(params);
//   return passText.replace('=', '%3D')
// }

// /**
//  * 接口参数密钥加密（body超长参数）
//  * @param {*} params
//  */
// function rsaEncrypt (params) {
//   let const = new Storage();
//   var encrypt = new JSEncrypt();
//   let publicKey = ls.get(`${global.env}-publicKey`)
//   publicKey && encrypt.setPublicKey(publicKey);
//   let passText = encrypt.encryptLong(JSON.stringify(params));
//   return passText
// }


// /**
//  * 接口参数密钥加密（body超长参数）
//  * @param {*} params
//  */
// function rsaEncryptGet (params) {
//   var encrypt = new JSEncrypt();
//   let const = new Storage();
//   let publicKey = ls.get(`${global.env}-publicKey`)
//   publicKey && encrypt.setPublicKey(publicKey);
//   let passText = encrypt.encryptLong(params);
//   return passText
// }

function rsaEncryptFun (params, type) {
  const ls = new Storage();
  var encrypt = new JSEncrypt();
  let publicKey = ls.get(`${global.env}-publicKey`)
  publicKey && encrypt.setPublicKey(publicKey);
  let passText = ''
  switch (type) {
    case 'str':
      // 需要把 = 替换成 %3D 时
      passText = encrypt.encryptLong(params);
      return passText.replace('=', '%3D')
    case 'obj':
      // 整个对象加密时
      passText = encrypt.encryptLong(JSON.stringify(params));
      return passText
    default:
      // 只加密某个字符串
      passText = encrypt.encryptLong(params);
      return passText
  }
}





function rsaDecrypt (msg) {
  var decrypt = new JSEncrypt();
  let key = "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAMF6n8CbL92vdrjKRD3lEj3LVQaUkwdj9ICWHPoqgVaa5kPzkTgTVn+bZLiGCmSlReSt5lj0mhk9P4NzDu0DJuHNADKVi7pxt6yZ/W9Hvk+euvPyx0vMWCf/ONzTvBb/ezm6qKBDJ+LdjyowPgZNVlcpisSwjc9SYVNSpHu+CzrPAgMBAAECgYEAtMgTRTC8BPPShs/X+81ywfKfu8pPp3QqHYwl/0qAF6Ac0Blh83d+NzXHYvM7+tbC++3RcgT7h+HG2thDdgqf5HGnG8GsabylxrcDNOWMCg4qrjqiRQihR4obTK2jRdQwWgEJwXDsWeUjypuMFA3GqUJcZKf/iKpAibIqw9Cp8cECQQD58F2dUKP6x+P+7o9t+A4O+C104+yQKxC2bUxqTd0s8liMfTMHOvtxHdCvR+ecZkg4D4vjc9mY5vwyq2U3K0dXAkEAxivAiChx6e/riPkvpVRpwKMAZSuyZiwv73hXxRXI0OuU3wZGvsCYWtgO8TkTw4nF1GC4qEuJ01NLUw6vTZxVSQJAe5c/Q2Y33+9uL4aZyCAsG3zfRXjbZqLU/dBoQ/zCzNH9tWLHk+C3q0S6B6K/xdfSCF6vpsaHqBM4THnyb+hnuwJBAInVfpl1gB3VaP6hSxl0SAXbmffEV9Ym38Rw8KM9Dqr5YFdrFyOv84gkBOiU6YE0v2uDRoyP1bItmhOQADA8DzkCQHPxgtIRrRueUlzK0VhgQv10r7WDSuJKlpMouiBLin19G3fTMtdHjjZUFsJ95LdJEKEkSB18tB9u9vYuDXFTYao="
  decrypt.setPrivateKey(key);
  var decryptMsg = decrypt.decryptLong(msg);
  return decryptMsg;
}





// console.log('---paramsSign 加密--->', paramsSign({ ber: 345, gth: 'hhh', ert: 'rrr', aqw: 'qqq' }))
